import { useStoreMap } from 'effector-react'
import { driverModel } from '~/entities/Driver'

export const useMainTaxipark = () => {
  const mainTaxipark = useStoreMap(driverModel.$driver, (driver) =>
    (driver?.getTaxiparks() || []).find(
      (taxipark) => taxipark.getApiId() === driver?.getMainTaxiparkId(),
    ),
  )

  return {
    ...mainTaxipark?.getAttributes(),
    id: mainTaxipark?.getApiId() as UniqueId,
  }
}
